import iconPlayHover from '../svg/pricing/icon_play-hover.svg';

const __ = window.__;

const CDN_HELP_IMAGES_BASE = 'https://cdn.ganttpro.com/statics/media/images/help-center';

const HELP_IMAGES = {
  customGridFields: {
    en: `${CDN_HELP_IMAGES_BASE}/custom-fields-land-en.png`,
    ru: `${CDN_HELP_IMAGES_BASE}/custom-fields-land-ru.png`,
    de: `${CDN_HELP_IMAGES_BASE}/custom-fields-land-de.png`,
    es: `${CDN_HELP_IMAGES_BASE}/custom-fields-land-es.png`,
    fr: `${CDN_HELP_IMAGES_BASE}/custom-fields-land-fr.png`,
    kr: `${CDN_HELP_IMAGES_BASE}/custom-fields-land-kr.png`,
    pt: `${CDN_HELP_IMAGES_BASE}/custom-fields-land-pt.png`,
  },
  publicLinkHelpBlock: {
    en: `${CDN_HELP_IMAGES_BASE}/project_sharing_en.png`,
    ru: `${CDN_HELP_IMAGES_BASE}/project_sharing_ru.png`,
    de: `${CDN_HELP_IMAGES_BASE}/project_sharing_de.png`,
    es: `${CDN_HELP_IMAGES_BASE}/project_sharing_es.png`,
    fr: `${CDN_HELP_IMAGES_BASE}/project_sharing_fr.png`,
    kr: `${CDN_HELP_IMAGES_BASE}/project_sharing_kr.png`,
    pt: `${CDN_HELP_IMAGES_BASE}/project_sharing_pt.png`,
  },
};

function getHelpImage(key) {
  const images = HELP_IMAGES[key];

  if (!images) return '';

  return images[user.locale] || images.en || '';
}

const helpTemplates = {
  defaultHelpInfoBlock: {
    width: 450,
    height: 492,
    title: 'Main view',
    text: "<div class='help-block'><img style='max-width:220px;margin:0 auto 40px;display:block;' src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAbAAAAFQCAMAAADp1NuaAAABF1BMVEUAAAD////////////+/v7////////////////////////////19fX////////////+/v7////////+/v7////7+/v////////9/f3////6+vrr6+v////y8vLW1tZJkOLt7e38/Pzw8PD39/f4p6SK35742Jj8/f9MkuPq6upZmuVoo+iXwO+cxPDg7fvX5/pup+nk5OTY2Nj2+v5KkeOwz/NjoOdfnuZTluTu9f2Ou+56r+tQlOT19fXN4fjR4/i30/T5/P691/Xo8vypy/KEtezk7/vC2vakyPGJt+3d4+t1q+ry9/7I3veTve6Bsuuzy+jz4N/Z7d7z69z1vbup5Lf24LP2rquU4Kb32qD1zs3A6cr15sdNzZSAAAAAGnRSTlMA/uvz5gxaq2/5PtzRvp0q05Ub8IBOM8mNB4kdnZQAAA0RSURBVHja7Nq7buJAGIZhF5uOloaZwQZycjhIUEXKHVBBOCe5/+tY7OBtXKzxrjLzDe9TI2PpldE/v0kK3Y5D8Drd5NsduUR07spevxxE/CqK8XwJ6SRJ10FIlwdMSydxkEIwMQQTQzAxiatZbw+H7dqVNvvTab9xf7zvjsfdu4M39WAf96UPd/b1WPpyF58PpU8HT+rB1vcXa+c2jxcbV3p/uOAZ86UebFsF2zq3r4LtXWlXBds5+FEPdqiCHZw7VcFOrnSsgh0d2iDY7eEnUQxDhxjGejEcnMWwmhJDMDEEE0MwMQQTQzAxBBNDMDFJH1IIJoZgYggmhmBiCCaGYGIIJqYebDHPzVXy+eKfrtDu2+rfV/9cjGrBFrm5Wr5of4U239bsjvMoi9WCzU0L8xZXaG/e8I7n/QjVguWmhbzFFdrLG95x3o9QLZhppc0V2mt6x/0IEUwMwcQQTAxDhxjGejEcnMWwmhLD8lcMwcQQTAzBxBBMDMHEEEwMwcQkPfyVDQjBCBYfGxCCESw+NiAEI1h8bEAIRrD42IAQjGDxsQEhGMHiYysDlxkvMjcg2PXBBpnxJhsQ7OpgznjkCHZ1sMx4lBHs6mDGK4IRLFYEE0MwMQwdYhjrxXBwFsNqSowNCMEIFh8bEIIRLD42IAQjWHxsQAhGsPjYbxycVdgSqykZtsTyV4Yt8XpFBi8wxRBMDMHEEEwMQ4cYxnoxHJzFhL+aGg3NzRmOdJe/I3OTRrLBbvD5Kgxlg5kbRTAxBBNDMDEEE0MwMbIHZ8Z6sdUUB2e15S+rKV6vKOMFphiCiSGYGIKJYegQE/5YD62DM8RWUxBb/oJg0mxACEaw+NiAECyKYKNhZv6bbDjqabMXs+n4NfXidTyd/eQLTPFitvQ0eU49ep48/dxfBIY9ad+93lLP3p5+7k84PWm2MEm9mxCsebBZ8Xv4sloaL5arl+JXcUawRqoH7GVpvFkWxaYEaxxsnKbpyni0Ot/AmGCNgxXz/NJ4tCyme4I1DpaeGa/SM8b6OIJxcBYLxmpKLRi0hg6IjfWoB5uGcHD+zd65LacNA2E4vIa1jMG+gCEpeIZDQhpIIOfJ6f3fppZqpZkyBLS2tbLzfzNNr9KLfmNr9e9KPoOwdkRToGHhL2hYewU0rIEJGjYiAJo2hAMgrMlQQEAYhLUPsnCPG3U+/wHFAceNPB/oi+iTlWJR24E+gWta9jdvgjkyqx+w7WgxKfGI+Twym6qa2WcslEPpPSLaXJmsnTqKS8+bsERVAG8AIYxrH/SzsY5zHoiI/7/hTZiqneg/AhOWku7O5MyJKFU8IMyfMF0uZFrYS4lFDMJ8CTOLz3Ro8ttX/jsRwjwVHXYJM2xLFPY9CPNS1tslzHBf4p3YhTAvG2e7hBkuBuzntNdHWe8nmrJLmGHNeyeaaAobZ3/h7zoueCc+iKb8CftlhZ2TG0jrZYRlsWVMLkCYhDCzhFmeyAEIExL2Fn+SkQMQJiPMLmFXs/zHko4HwmSE2SVs9JL/uKHjgTAZYdNZbFjc6fFdOhoIE9g4d4slbKjXrwf9XpwSURL0xrn5lIimbJCYme7KIv/5qMOOoKOp5kMFXX6QeJn/+TDqLokoUq7gGnSOMF6Q+DqL49k8V/VM17r0YAXA+NAAs4HJXMKyGxMkDkb5XxNWFxOf8vAibEVET/oo3t3fm6Kei8K+C2FfCEzYVj9VevW6I5oM44tbPGH/EZAws/DMP7Z0VgxNjW+0r776wcLSpL4WTfmZDvu7ukrcfjew/WOKjlRVQlpTWW+3T/dmB1YQqV1+TFmfqEpI6prpSCLS/DbzAYb+Su3yczbOqiLqO26UdIgoK+r5VTdRx9LOaEoxYAvjc2pG63m0K/xtiLARsxUGYTLCNjqwJ3cgTEjYA3NiCsKEhK1Nd8WdFgrzWdbzuTFhvTstFOZz48znyWS/7rRQmM9ois+7iRLdaaOwbwhkCKcIOt7IHQgTEnbKnNKGMBlh5k7uV3IHwmSETfV8G7kDYULCxnqMlNyBMCFha+bIL4QJHJmNin3zpetoQEvbK3sJY/LXjJKaiY4n91ZzKxuY+wli8lepjt2GcWY5WjgisJcgJn8LYSPdvuQYb+EQzjcEMOamVEJEy6Kq7yhnWjjmtktQwlZFkZhB2F6CEqZ/eX5UkQhhQQjTxd1lkdVHQQgr295owAcXyxQdZsaNf2nRbtERQAMxeGPcst4KuypGphJVAlvWB9CiD/6jwcyNsy0Sb/UxPmbNsbtxDmEIJgqcEtHUqjjR95svzEZTEOYl/LUn+qgsEOZN2AfzPhUIExI2Ys4HQJiMsLH5YrY7ECYkbG6u6CgPynpPwp4rmknExtmTMHs3R1kQTfkRZm4EGxALzHT43DjbeQ7WthkzHSLRlI3q7xhRPWY6BMJfnfye2+PoyhHMdHhvr3SL5PeKdYEbZjq8NzCj4qapF94Sho6zb2EdvYQdNZIIYSEIS4j+3pB4rZcwCNtLKMJSon93kCYQtp9Aig47pH15cAlD0RFCWd+zRf3b4SUMZX0AG+eUiCa6qN8ceiNi4xxFAURT/eLK+vtDb0REU5owwt9TcxEpA4S/EsJMUj+ckjMQJiSM+3UcCBMSljHnpYIQliY9JUIvSYWELfVHPJbkTBDCUiVIKiPsjnnpXhDCEiVIIiPsnDl+E4QwJYqIsLX9vpsjECYk7N7kiO5AmIyw5ZA33wZhOb6jqX5RcpzqWCpRJTHRFITVGP4mlLMoSo6+qoJeH8Lqa69EtuR4tb3m8nRR1tfXwOx8KTk6qhp62DjXNiKQfi05IlURiKZqE9Y5vuQIWFiDoQKHB2wz+iw5IMwBEWGd4hTfxcGSA8J2EJiaWhHRQMeIvw6XHAEXHU3Gqaw3D9iNqekPlxwBl/VN5t/G2fkBq6jQwtRU5dHU7gO2rOwBw9RUzeHvYMG9+yag8LfJkCNbPSy1JGcgTEaYmUZ8J3cgTEbYo37AbskZCJMRNljwOs0QJiPMpIjDB3IGwmSELS94JSKEyQgzh5pHr1QXJyE3RrhtE0lhkxlvPPtoYYG3HlmNSUlhme6DDag2TgJv7rNa/4LCtnHONdXHSejjM98TeYGOZjoyRy6dgTAhYWc69WXsmSFMRtj1zNx74wyEyQib6jbYYkOuQJiQsPfc12xCzkCYjLB1bPrMLFDW+xdmXoinG+KBjbNvYSaTGk6ICaIp38LeSr4QEf76FXY74mVSEJYjIGyQ8V6IEKYREPYe824MgLAcAWHbmJchQpjGv7DxlY44puQKhBm8C5sudOY7JlcgzOJZ2EfMuxYRwix+hZ3FvLEbCLP4FTbXvrIBuQJhFr/CHnUP7HxJrkDYDl6EXQ/14dgxuQJhO3gRNv7Trp3upgpEARyfQSoucfe21pxkcj9BQMVE3I3UFY1d3v9tbgeY1qVtCiYyuTm/V/jnnBkHR/yFw4WoMFgc1wcb808qjgdRYbA4rg/2bMV7kcJgcVwfbGzFu9BjsOiuDyZ6bSAqDBbH9cHGA95rqkNEGCy664OJXm+Re2GwOK4PtorZC4PdAFxaDf3zK3IvDHYLcME24/XCYDcB57wZ77WP3AuD3QacWTu81yRyLwx2I3BCf2XcDhJBak0UKVhvynMZS0gGKTdRlGBbi/cyXUgIaTRRhGDeiPcabiEppNREvw6mtxjXfYbEEFJpol8GW3UZt19Acgh5LDTRr4K9+Otw9gRJIu/FcMZ+RoFbtBg36ECiCFdqlPF2/52/FDjbYtymB8ki6Ed/FOAWbYfnMvrAZdMESan6EI7XgHFDGzi1SpCUiuL0chj36q9DqhEkpUwKfPNwvFxchzJLK+BbbRjntHq4DiWWU8NtuJsxbuACrkN55fIUfN4wHK8FcEqOIPmkRS63y3xdGzhaJEg+aSXM1Zkyn7kEn3JPkGzuKikIbPcO44x2D8dLVqUChUBnbzDfZgs+FcdLOpm8yGW/Ocw3tcGXyhAkl1whC6H5gQW6c/BR7ZEgmVQrihiuXn/AApYX5iqXCJJItaJSCG1bIzFdLxBQ/xAkj+NaC2/qsMDUhYCCD4cSSRdSFAT7VQyXsbcB7xqyyVXyFD6s1hYLmbuxyFUnSAq5Yj4Ln7brLhMOni6WIU6XDHKNB4XCkc5RLbPdgQBV8exKWilTFK2EnjcxmWBsXnSRq4yP8om5u0/Xi4V8isKphbs7GJ+1pk/PEMpq+IkyKRrvdKn3HmvGjmuNIURVPLoSU1K+atXfDxz2abTxZ0sMFz5qJKh2mqrjrUUrwWq7Ogi0jBeNRBWB08cdd7meHEx2ZjhZruADzdfvCEpUCgDmQ/YFw+KxsJZkKABc9HKsSd9ewJHsQwZrSeEsmDF4az+FrQSqaPiLSxrBSjRM67Bv9+crHU7RWgFHSyoafIsqGEtCyjet6vh/GjmVaielsrWyhq3kVkxRSrMptaw10v/NCvwHaZPwzzG2+qUAAAAASUVORK5CYII='><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci asperiores aut culpa facilis impedit mollitia neque quos suscipit unde voluptatem. Atque magni nihil voluptates. Doloremque maxime nostrum quam recusandae voluptatibus?</p></div><div class=\"help-block-buttons\"><div class=\"help-block-button grey-help\"> FAQ</div><div class=\"help-block-button blue-help\">Start tour</div></div>",
  },
  newProjectBlock(id) {
    return {
      title: __('new_project_help_title'),
      text:
        `${"<div class='view-help'>"
        + "  <div class='help-block'>"}${__('new_project_help_text')}</div>`
        + '  <div class=\'help-desc\'>' + `<a class='desc-link' href=${__('new_project_help_read_more')} target='_blank'>${__('new_project_help_read_more_text')}</a>` + '</div>'
        + '</div>',
    };
  },
  importProjectBlock(id) {
    return {
      title: __('import_project_help_title'),
      text:
        `${"<div class='view-help'>"
        + "  <div class='help-block'>"}${__('import_project_help_text')}</div>`
        + '  <div class=\'help-desc\'>' + `<a class='desc-link' href=${__('import_project_help_read_more')} target='_blank'>${__('import_project_help_read_more_text')}</a>` + '</div>'
        + '</div>',
    };
  },
  saveUserTemplateHelpBlock(id) {
    return {
      title: __('save_user_help_title'),
      text:
        `${"<div class='view-help'>"
        + "  <div class='help-block'>"}${__('save_user_help_text')}</div>`
        + '  <div class=\'help-desc\'>' + `<a class='desc-link' href=${__('save_user_help_read_more')} target='_blank'>${__('save_user_help_read_more_text')}</a>` + '</div>'
        + '</div>',
    };
  },
  baselineHeaderHelpBlock(id) {
    return {
      title: __('baseline_help_title'),
      text:
        `${"<div class='view-help'>"
        + "  <div class='help-block'>"}${__('baseline_help_text')}</div>`
        + '  <div class=\'help-video\'>'
        + `      <div class='video-play hover'>${iconPlayHover}</div>`
        + `      <img class='promo-video-image js-show-global-video-fullscreen' data-video-src='${__('baseline_help_video')}' src='${__('baseline_help_img')}' data-video-id='${id}' data-video-class='ratio_16-12'>`
        + '  </div>'
        + '  <div class=\'help-desc\'>' + `<a class='desc-link' href=${__('baseline_help_read_more')} target='_blank'>${__('baseline_help_read_more_text')}</a>` + '</div>'
        + '</div>',
    };
  },
  toolBarExportHelpBlock(id) {
    return {
      title: __('export_help_title'),
      text:
        `${"<div class='view-help'>"
        + "  <div class='help-block'>"}${__('export_help_text')}</div>`
        + '  <div class=\'help-video\'>'
        + `      <div class='video-play hover'>${iconPlayHover}</div>`
        + `      <img class='promo-video-image js-show-global-video-fullscreen' data-video-src='${__('export_help_video')}' src='${__('export_help_img')}' data-video-id='${id}' data-video-class='ratio_16-12'>`
        + '  </div>'
        + '  <div class=\'help-desc\'>' + `<a class='desc-link' href=${__('export_help_read_more')} target='_blank'>${__('export_help_read_more_text')}</a>` + '</div>'
        + '</div>',
    };
  },
  publicLinkHelpPopup(id) {
    return {
      title: __('public_link_popup_help_title'),
      text:
        `${"<div class='view-help'>"
        + "  <div class='help-block'>"}${__('public_link_popup_help_text')}</div>`
        + '  <div class=\'help-video\'>'
        + `      <div class='video-play hover'>${iconPlayHover}</div>`
        + `      <img class='promo-video-image js-show-global-video-fullscreen' data-video-src='${__('public_link_popup_help_video')}' src='${__('public_link_popup_help_img')}' data-video-id='${id}' data-video-class='ratio_16-12'>`
        + '  </div>'
        + '  <div class=\'help-desc\'>' + `<a class='desc-link' href=${__('public_link_popup_help_read_more')} target='_blank'>${__('public_link_popup_help_read_more_text')}</a>` + '</div>'
        + '</div>',
    };
  },
  publicLinkHelpBlock(id) {
    return {
      title: __('public_url_help_title'),
      text:
        `${"<div class='view-help'>"
        + "  <div class='help-block'>"}${__('public_url_help_text')}</div>`
        + '  <div class=\'help-video\'>'
        + `      <div class='video-play hover'>${iconPlayHover}</div>`
        + `      <img class='promo-video-image js-show-global-video-fullscreen' data-video-src='${__('public_url_help_video')}' src='${getHelpImage('publicLinkHelpBlock')}' data-video-id='${id}' data-video-class='ratio_16-12'>`
        + '  </div>'
        + '  <div class=\'help-desc\'>' + `<a class='desc-link' href=${__('public_url_help_read_more')} target='_blank'>${__('public_url_help_read_more_text')}</a>` + '</div>'
        + '</div>',
    };
  },
  filterPopupHelpBlock(id) {
    return {
      title: __('filter_help_title'),
      text:
        `${"<div class='view-help'>"
        + "  <div class='help-block'>"}${__('filter_help_text')}</div>`
        + '  <div class=\'help-video\'>'
        + `      <div class='video-play hover'>${iconPlayHover}</div>`
        + `      <img class='promo-video-image js-show-global-video-fullscreen' data-video-src='${__('filter_help_video')}' src='${__('filter_help_img')}' data-video-id='${id}' data-video-class='ratio_16-12'>`
        + '  </div>'
        + '  <div class=\'help-desc\'>' + `<a class='desc-link' href=${__('filter_help_read_more')} target='_blank'>${__('filter_help_read_more_text')}</a>` + '</div>'
        + '</div>',
    };
  },
  filterViewHelpPopup(id) {
    return {
      title: __('filter_view_help_title'),
      text:
        `${"<div class='view-help'>"
        + "  <div class='help-block'>"}${__('filter_view_help_text')}</div>`
        + '  <div class=\'help-desc\'>' + `<a class='desc-link' href=${__('filter_view_help_read_more')} target='_blank'>${__('filter_view_help_read_more_text')}</a>` + '</div>'
        + '</div>',
    };
  },
  settingsHelpBlock(id) {
    return {
      title: __('settings_help_title'),
      text:
        `${"<div class='view-help'>"
        + "  <div class='help-block'>"}${__('settings_help_text')}</div>`
        + '  <div class=\'help-desc\'>' + `<a class='desc-link' href=${__('settings_help_read_more')} target='_blank'>${__('settings_help_read_more_text')}</a>` + '</div>'
        + '</div>',
    };
  },
  columnsSidebarStandartColumns(id) {
    return {
      title: __('custom_grid_help_title'),
      text:
        `${"<div class='view-help'>"
        + "  <div class='help-block help-block__desc'>"}${__('custom_grid_help_block_desc_01')}</div>`
        + '  <div class=\'help-desc\'>' + `<a class='desc-link' href=${__('custom_grid_help_read_more_01')} target='_blank'>${__('custom_grid_help_read_more_text_01')}</a>` + '</div>'
        + '</div>',
    };
  },
  columnsSidebarCustomColumns(id) {
    return {
      title: __('custom_grid_help_title'),
      text:
        `${"<div class='view-help'>"
        + "  <div class='help-block help-block__desc'>"}${__('custom_grid_help_block_desc_01')}</div>`
        + '  <div class=\'help-desc\'>' + `<a class='desc-link' href=${__('custom_grid_help_read_more_02')} target='_blank'>${__('custom_grid_help_read_more_text_01')}</a>` + '</div>'
        + '</div>',
    };
  },
  customGridFields(id) {
    return {
      title: __('custom_grid_help_title'),
      text:
        `${"<div class='view-help'>"
        + "  <div class='help-block'>"}${__('custom_grid_fields_help_text')}</div>`
        + '  <div class=\'help-video\'>'
        + `      <div class='video-play hover'>${iconPlayHover}</div>`
        + `      <img class='promo-video-image js-show-global-video-fullscreen' data-video-src='${__('custom_grid_fields_help_video')}' src='${getHelpImage('customGridFields')}' data-video-id='${id}' data-video-class='ratio_16-12'>`
        + '  </div>'
        + '  <div class=\'help-desc\'>' + `<a class='desc-link' href=${__('custom_grid_fields_help_read_more')} target='_blank'>${__('custom_grid_fields_help_read_more_text')}</a>` + '</div>'
        + '</div>',
    };
  },
  taskCostHelpBlock(id) {
    return {
      title: __('custom_grid_help_block_title_02'),
      text:
        `${"<div class='view-help'>"
        + "  <div class='help-block help-block__desc'>"}${__('custom_grid_help_block_desc_02')}</div>`
        + '  <div class=\'help-video\'>'
        + `      <div class='video-play hover'>${iconPlayHover}</div>`
        + `      <img class='promo-video-image js-show-global-video-fullscreen' data-video-src='${__('custom_grid_help_video_02')}' src='${__('custom_grid_help_img_02')}' data-video-id='${id}' data-video-class='ratio_16-12'>`
        + '  </div>'
        + '  <div class=\'help-desc\'>' + `<a class='desc-link' href=${__('custom_grid_help_read_more_02')} target='_blank'>${__('custom_grid_help_read_more_text_02')}</a>` + '</div>'
        + '</div>',
    };
  },
  userNotificationHelpBlock(id) {
    return {
      title: __('user_notification_help_title'),
      text:
        `${"<div class='view-help'>"
        + "  <div class='help-block'>"}${__('user_notification_help_text')}</div>`
        + '  <div class=\'help-video\'>'
        + `      <div class='video-play hover'>${iconPlayHover}</div>`
        + `      <img class='promo-video-image js-show-global-video-fullscreen' data-video-src='${__('user_notification_help_video')}' src='${__('user_notification_help_img')}' data-video-id='${id}' data-video-class='ratio_16-12'>`
        + '  </div>'
        + '  <div class=\'help-desc\'>' + `<a class='desc-link' href=${__('user_notification_help_read_more')} target='_blank'>${__('user_notification_help_read_text')}</a>` + '</div>'
        + '</div>',
    };
  },
  createTemplateHelpBlock(id) {
    return {
      height: 384,
      title: __('create_template_help_title'),
      text:
        `${"<div class='view-help'>"
        + "  <div class='help-block'>"}${__('create_template_help_text')}</div>`
        + '  <div class=\'help-video\'>'
        + `      <div class='video-play hover'>${iconPlayHover}</div>`
        + `      <img class='promo-video-image js-show-global-video-fullscreen' data-video-src='${__('create_template_help_video')}' src='${__('create_template_help_img')}' data-video-id='${id}' data-video-class='ratio_16-12'>`
        + '  </div>'
        + '  <div class=\'help-desc\'>' + `<a class='desc-link' href=${__('create_template_help_read_more')} target='_blank'>${__('create_template_help_read_text')}</a>` + '</div>'
        + '</div>',
    };
  },
  historyHelpPopup(id) {
    return {
      title: __('history_help_title'),
      text:
        `${"<div class='view-help'>"
        + "  <div class='help-block'>"}${__('history_help_text')}</div>`
        + '  <div class=\'help-desc\'>' + `<a class='desc-link' href=${__('history_help_read_more')} target='_blank'>${__('history_help_read_text')}</a>` + '</div>'
        + '</div>',
    };
  },
  userProfileHelpBlock(id) {
    return {
      title: __('user_profile_help_title'),
      text:
        `${"<div class='view-help'>"
        + "  <div class='help-block'>"}${__('user_profile_help_text')}</div>`
        + '  <div class=\'help-video\'>'
        + `      <div class='video-play hover'>${iconPlayHover}</div>`
        + `      <img class='promo-video-image js-show-global-video-fullscreen' data-video-src='${__('user_profile_help_video')}' src='${__('user_profile_help_img')}' data-video-id='${id}' data-video-class='ratio_16-12'>`
        + '  </div>'
        + '  <div class=\'help-desc\'>' + `<a class='desc-link' href=${__('user_profile_help_read_more')} target='_blank'>${__('user_profile_help_read_more_text')}</a>` + '</div>'
        + '</div>',
    };
  },
  resourcesLayoutHelpPopup(id) {
    return {
      title: __('resources_layout_help_title'),
      text:
        `${"<div class='view-help'>"
        + "  <div class='help-block'>"}${__('resources_layout_help_text')}</div>`
        + '  <div class=\'help-video\'>'
        + `      <div class='video-play hover'>${iconPlayHover}</div>`
        + `      <img class='promo-video-image js-show-global-video-fullscreen' data-video-src='${__('resources_layout_help_video')}' src='${__('resources_layout_help_img')}' data-video-id='${id}' data-video-class='ratio_16-12'>`
        + '  </div>'
        + '  <div class=\'help-desc\'>' + `<a class='desc-link' href=${__('resources_layout_help_read_more')} target='_blank'>${__('resources_layout_help_read_more_text')}</a>` + '</div>'
        + '</div>',
    };
  },
  manageTeamLayoutHelpPopup(id) {
    return {
      title: __('manage_team_layout_help_title'),
      text:
        `${"<div class='view-help'>"
        + "  <div class='help-block'>"}${__('manage_team_layout_help_text')}</div>`
        + '  <div class=\'help-video\'>'
        + `      <div class='video-play hover'>${iconPlayHover}</div>`
        + `      <img class='promo-video-image js-show-global-video-fullscreen' data-video-src='${__('manage_team_layout_help_video')}' src='${__('manage_team_layout_help_img')}' data-video-id='${id}' data-video-class='ratio_16-12'>`
        + '  </div>'
        + '  <div class=\'help-desc\'>' + `<a class='desc-link' href=${__('manage_team_layout_help_read_more')} target='_blank'>${__('manage_team_layout_help_read_more_text')}</a>` + '</div>'
        + '</div>',
    };
  },
  workloadHelpBlock(id) {
    return {
      title: __('workload_help_title'),
      text:
        `${"<div class='view-help'>"
        + "  <div class='help-block'>"}${__('workload_help_text')}</div>`
        + '  <div class=\'help-desc\'>' + `<a class='desc-link' href=${__('workload_help_read_more')} target='_blank'>${__('workload_help_read_more_text')}</a>` + '</div>'
        + '</div>',
    };
  },
};

function sendAnalytic(popup_id) {
  let id = popup_id;

  switch (popup_id) {
    case 'workloadHelpBlock': id = 'workload'; break;
    case 'settingsHelpBlock': id = 'project settings'; break;
    case 'taskCostHelpBlock': id = 'cost field'; break;
    case 'publicLinkHelpBlock': id = 'public url'; break;
    case 'manageTeamLayoutHelpPopup': id = 'team & resources'; break;
    case 'saveUserTemplateHelpBlock': id = 'save template'; break;
    case 'newProjectBlock': id = 'new project'; break;
    case 'historyHelpPopup': id = 'history'; break;
    case 'columnsSidebarStandartColumns': id = 'custom grid columns'; break;
    case 'columnsSidebarCustomColumns': id = 'custom grid columns'; break;
    case 'filterViewHelpPopup': id = 'filter settings'; break;
    case 'importProjectBlock': id = 'project import'; break;
    case 'resourcesLayoutHelpPopup': id = 'people'; break;
  }
  userExtAnalytics.log('help_video_popup_open', { id });
}

const helpInfoObject = {};

helpInfoObject.getInfoById = function (id) {
  const name = id;

  sendAnalytic(id);
  if (helpTemplates[id]) {
    return helpTemplates[id](id);
  }
  const keys = _.keys(helpTemplates);
  const foundKey = _.find(keys, key => id.indexOf(key) !== -1);

  return foundKey && helpTemplates[foundKey](foundKey);
};

export default helpInfoObject;
